import WMSCapabilities from 'ol/format/WMSCapabilities.js';
import { mytephi, my_circle } from '../index.js'

const controller = new AbortController();
const { signal } = controller;

class Tephi_var {
  constructor(nomvar) {
    this.nomvar = nomvar;
    this.present = false;
    this.p_max = null;
    this.p_min = null;
    this.data = [];
    this.levels = [];
    this.diag = null;
    this.mult = null;
  }
}

class Tephi_prof {
  constructor(model, lat, lon) {
    this.model = model;
    this.lat = lat;
    this.lon = lon;
    this.grid_point_coor = null; // Array [longitude,latitude]
    this.dateo_wms_format = null;
    this.datev_wms_format = null;
    this.datev = null;
    this.p0 = null;
    this.knams = 0.5147910000000E+00;
    this.ind_T = 0;
    this.ind_Td = 1;
    this.ind_UU = 2;
    this.ind_WD = 3;
    this.ind_GZ = 4;
    this.tephi_var = new Array(5);
    this.tephi_var[0] = new Tephi_var("TT");
    this.tephi_var[1] = new Tephi_var("ES");
    this.tephi_var[2] = new Tephi_var("WSPD");
    this.tephi_var[3] = new Tephi_var("WD");
    this.tephi_var[4] = new Tephi_var("GZ");
    this.tephi_var[this.ind_T].mult = 1.;
    this.tephi_var[this.ind_Td].mult = 1.;
    this.tephi_var[this.ind_UU].mult = 1. / this.knams;
    this.tephi_var[this.ind_WD].mult = 1.;
    this.tephi_var[this.ind_GZ].mult = 1.;
    if (this.model == "HRDPS") {
      this.resolution = 2.5;
      this.layer_mod_pres = 'HRDPS.CONTINENTAL.PRES_';
      // Name for diag TT, TD, WSPD, WD and P0
      this.layer_mod_diag = 'HRDPS.CONTINENTAL_';
    } else if (this.model == "RDPS" || this.model == "GDPS") {
      this.resolution = 10.;
      this.layer_mod_pres = this.model + ".PRES_";
      // Name for diag TT, TD, WSPD, WD and P0
      this.layer_mod_diag = this.model + ".ETA_";
    } else {
      alert('Internal error in class Tephi_prof, add variable ' + this.model + ' to this.layer_mod_pres');
      return;
    }
  }
  get_nb_of_layers() {
    var count = 0;
    for (let i = 0; i < this.tephi_var.length; i++) {
      if (this.tephi_var[i].present) {
        count = count + this.tephi_var[i].levels.length
        // Add diag level
        count++
      }
    }
    // Add surface pressure
    count++
    return count;
  }
  is_a_sub_profile(profile) {
    // profile is the candidate to a match
    // "this." is the current user request.
    var debug = false;
    
    if (this.model != profile.model) {
      if (debug) { console.log("From method is_a_sub_profile, not same model"); }
      return false;
    }
    if (this.lat != profile.lat && this.lon != profile.lon) {
      // lat lon may not be the same but actual grid point may be the same.
      if (this.distance_from_grid_point(profile.grid_point_coor[1], profile.grid_point_coor[0])
        > .5 * this.resolution) {
        if (debug) { console.log("From method is_a_sub_profile, not same grid point, distance=" + this.distance_from_grid_point(profile.grid_point_coor[1], profile.grid_point_coor[0])); }
        return false;
      }
    }
    if (this.dateo_wms_format != profile.dateo_wms_format) {
      if (debug) { console.log("From method is_a_sub_profile, not same dateo"); }
      return false;
    }
    if (this.datev_wms_format != profile.datev_wms_format) {
      if(debug){console.log("From method is_a_sub_profile, not same datev");}      
      return false;
    }
    for (let i = 0; i < this.tephi_var.length; i++) {
      if (this.tephi_var[i].present == true) {
        if (profile.tephi_var[i].present == false) {
          if (debug) { console.log("From method is_a_sub_profile, no " + this.tephi_var[i].nomvar); }
          return false;
        }
        if(this.tephi_var[i].p_max == "Surface") {
          if(profile.tephi_var[i].p_max != "Surface") {
            if (debug) { console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max); }
            return false;
          }
        }else{
          if(profile.tephi_var[i].p_max == "Surface") {
            if (debug) { console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max); } 
            return false;
          }
          if (parseInt(this.tephi_var[i].p_max) > parseInt(profile.tephi_var[i].p_max)) {
            if (debug) { console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max); }
            return false;
          }
        }
        if (parseInt(this.tephi_var[i].p_min) < parseInt(profile.tephi_var[i].p_min)) {
          if (debug) { console.log("From method is_a_sub_profile, no match for p_min, candidate is " + profile.tephi_var[i].nomvar + " current value is " + this.tephi_var[i].p_min); }
          return false;
        }
      }
    }
    return true;
  }
  distance_from_grid_point(grid_point_lat, grid_point_lon) {
    var deg2rad = 0.3141592653590E+01 / 180.;
    var lon1 = grid_point_lon * deg2rad;
    var lat1 = grid_point_lat * deg2rad;
    var lon2 = this.lon * deg2rad;
    var lat2 = this.lat * deg2rad;
    return Math.acos(Math.sin(lat1) * Math.sin(lat2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)) * 0.6371220000000E+04
  }
}

class WMS_request {
  constructor(tephi_control, levels) {
    this.tephi_control = tephi_control;
    this.tephi_prof_list = [];
    this.levels = levels;
    this.model = null;
    this.cap = null;
    this.ec_wms_url = "https://geo.weather.gc.ca/geomet?SERVICE=WMS&VERSION=1.3.0"
    this.progress_bar = new Progress_bar(document.getElementById("id_progress"));
    this.dateo = new Date();
    this.datev = new Date();
    this.dateo_stmp = null;
    this.request_completed = 1;
    this.bbox = null;
    this.now = null;
    this.hh_min_delta_fcst = null;
    this.hhh_end = null;
    this.url_dateo = null;
  }

  async get_fcst_dates(lat, lon) {
    this.clear_datev_menu();
    this.model = this.tephi_control.get_model();
    this.tephi_control.id_message.innerHTML = "Obtention de la date d'origine et des heures de pr&eacute;vision pour le " + this.model;

    // Abort any fetch requests
    if (this.request_completed == 0) {
      controller.abort();
      this.request_completed = 1;
      return
    }
    this.request_completed = 0;
    var lat_min = lat - .0001;
    var lat_max = lat + .0001;
    var lon_min = lon - .0001;
    var lon_max = lon + .0001;
    this.bbox = lat_min + ',' + lon_min + ',' + lat_max + ',' + lon_max
    this.progress_bar.update_progress_bar(0.01);
    this.now = new Date();
    if (this.model == "RDPS") {
      this.mod_lay = this.model + '.ETA_TT';
    } else if (this.model == "HRDPS") {
      this.mod_lay = this.model + '.CONTINENTAL_TT';
    } else if (this.model == "GDPS") {
      this.mod_lay = this.model + '.ETA_TT';
    } else {
      console.log("Internale error in class Time_Series, please add model " + this.model)
      return
    }
    this.cap = await this.get_layer_capability();
    //console.log(this.cap);
    this.dateo_stmp = this.crack_cap("dateo");
    this.datef_stmp = this.crack_cap("datef");
    this.dateo = this.get_date_from_wms_date_stmp(this.dateo_stmp, 'local');
    this.datef = this.get_date_from_wms_date_stmp(this.datef_stmp, 'local');
    this.hhh_end = (this.get_date_from_wms_date_stmp(this.datef_stmp, 'local') -
      this.get_date_from_wms_date_stmp(this.dateo_stmp, 'local')) / (1000 * 60 * 60);
    this.hh_min_delta_fcst = parseInt(this.crack_cap("hh_min_delta_fcst"));
    this.url_dateo = this.set_url_date(this.mod_lay, this.dateo_stmp);
    //console.log(this.url_dateo);
    //console.log(this.dateo_stmp);
    //console.log(this.dateo);
    //console.log(this.datef_stmp);
    //console.log(this.datef);
    //console.log(this.hh_min_delta_fcst);
    //console.log(this.hhh_end)
    this.progress_bar.update_progress_bar(1.);
    this.set_datev_menu();
    this.request_completed = 1;
  }

  get_date_from_wms_date_stmp(wms_date, zone) {
    //2023-05-13T12:00:00
    //0123456789012345678
    //0         1
    var res = new Date(wms_date);
    if (zone == 'local') {
      return new Date(res.getTime());
    } else if (zone == 'UTC') {
      return res;
    } else {
      console.error("Error in get_date_from_wms_date_stmp, unsuported zone: " + zone);
      return null;
    }

  }

  async get_layer_capability() {
    const parser = new WMSCapabilities();
    var my_url = this.ec_wms_url + "&REQUEST=GetCapabilities&Layers=" + this.mod_lay
    console.log(my_url);
    return fetch(my_url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        const result = parser.read(text);
        // Pour tout voir a la console :
        console.log(JSON.stringify(result, null, 2));
        return result;
      })
      .catch((error) => {
        console.error('Error with fetch on GetCapabilities');
      });
  }
  crack_cap(item) {
    var text = this.cap.Capability.Layer.Layer[0].Layer[0].Layer[0].Dimension[0].values;
    if (item == "dateo") {
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(0, 20);
    } else if (item == "datef") {
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(21, 41);
    } else if (item == "hhh_end") {
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(21, 40);
    } else if (item == "hh_min_delta_fcst") {
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(44, 45);
    } else {
      console.error('In function crack_cap, item not supported: ' + item);
      return null;
    }
  }

  get_data() {
    if (!this.model || this.model == "UNDEF") {
      alert("Vous devez choisir un modèle avec le menu en haut à gauche");
      return;
    }
    var lat_min = this.lat - .1;
    var lat_max = this.lat + .1;
    var lon_min = this.lon - .1;
    var lon_max = this.lon + .1;
    this.bbox = lat_min + ',' + lon_min + ',' + lat_max + ',' + lon_max
    var tephi_prof = new Tephi_prof(this.model, this.lat, this.lon);
    tephi_prof.dateo_wms_format = Get_Wms_date_format(this.dateo);
    tephi_prof.datev = this.tephi_control.get_datev_menu_text();
    tephi_prof.datev_wms_format = this.tephi_control.get_datev_menu_value();
    //alert(tephi_prof.dateo_wms_format);
    //alert(tephi_prof.datev_wms_format);
    var fetch_data_L = this.set_pressure_info(tephi_prof);
    //try to find a saved profiles with this request
    var tephi_prof_found = this.find_saved_profile(tephi_prof);
    if (tephi_prof_found) {
      mytephi.clear_profile();
      this.tephi_control.id_message.innerHTML = "Donn&eacute;es obtenues de la cache"
      this.plot_tephi(tephi_prof_found);
      return;
    } else {
      this.tephi_prof_list.push(tephi_prof);
    }
    if (!fetch_data_L) {
      this.tephi_control.id_message.innerHTML = "Aucune donn&eacute;e s&eacute;lectionn&eacute;e!"
      return;
    }
    var nb = tephi_prof.get_nb_of_layers();
    var fetchs = new Array(nb);
    this.tephi_control.id_message.innerHTML = "Il y a " + nb.toString() + " couches &agrave; t&eacute;l&eacute;charger."
    var ind = 0
    // load surface pressure
    var url = this.set_url(tephi_prof, tephi_prof.layer_mod_diag + 'P0');
    fetchs[ind] = fetch(url, { signal })
      .then((res) => res.json())
      .then((data) => {
        tephi_prof.p0 = parseFloat(data.features[0].properties.value) / 100.;
        tephi_prof.grid_point_coor = data.features[0].geometry.coordinates;
        my_circle(tephi_prof.grid_point_coor, 'green');
        var count = 0;
        // Check profile progress
        for (let k = 0; k < tephi_prof.tephi_var.length; k++) {
          for (let g = 0; g < tephi_prof.tephi_var[k].levels.length; g++) {
            // Check pressure levels
            if (tephi_prof.tephi_var[k].data[g] > -998.) {
              count++;
            }
            // check diag progress
            if (tephi_prof.tephi_var[k].diag > -998.) {
              count++;
            }
          }
        }
        // check surface pressure
        if (tephi_prof.p0 > -998.) {
          count++;
        }
        this.progress_bar.update_progress_bar(count / nb);
        console.log(data);
      }).catch((error) => {
        tephi_prof.p0 = null;
        console.error('Error:', error);
      });
    ind++;
    for (let i = 0; i < tephi_prof.tephi_var.length; i++) {
      if (tephi_prof.tephi_var[i].present) {
        // load profile
        for (let j = 0; j < tephi_prof.tephi_var[i].levels.length; j++) {
          var url = this.set_url(tephi_prof, tephi_prof.layer_mod_pres + tephi_prof.tephi_var[i].nomvar + '.' + tephi_prof.tephi_var[i].levels[j]);
          console.log(url);
          fetchs[ind] = fetch(url, { signal })
            .then((res) => res.json())
            .then((data) => {
              tephi_prof.tephi_var[i].data[j] = parseFloat(data.features[0].properties.value *
                tephi_prof.tephi_var[i].mult);
              var count = 0;
              // Check profile progress
              for (let k = 0; k < tephi_prof.tephi_var.length; k++) {
                for (let g = 0; g < tephi_prof.tephi_var[k].levels.length; g++) {
                  // Check pressure levels
                  if (tephi_prof.tephi_var[k].data[g] > -998.) {
                    count++;
                  }
                  // check diag progress
                  if (tephi_prof.tephi_var[k].diag > -998.) {
                    count++;
                  }
                }
              }
              // check surface pressure
              if (tephi_prof.p0 > -998.) {
                count++;
              }
              this.progress_bar.update_progress_bar(count / nb);
              console.log(data);
            }).catch((error) => {
              tephi_prof.tephi_var[i].data[j] = null;
              console.error('Error:', error);
            });
          ind++;
        }
        // Load diag
        var url = this.set_url(tephi_prof, tephi_prof.layer_mod_diag + tephi_prof.tephi_var[i].nomvar);
        console.log(url);
        fetchs[ind] = fetch(url, { signal })
          .then((res) => res.json())
          .then((data) => {
            tephi_prof.tephi_var[i].diag = parseFloat(data.features[0].properties.value *
              tephi_prof.tephi_var[i].mult);
            var count = 0;
            // Check profile progress
            for (let k = 0; k < tephi_prof.tephi_var.length; k++) {
              for (let g = 0; g < tephi_prof.tephi_var[k].levels.length; g++) {
                // Check pressure levels
                if (tephi_prof.tephi_var[k].data[g] > -998.) {
                  count++;
                }
                // check diag progress
                if (tephi_prof.tephi_var[k].diag > -998.) {
                  count++;
                }
              }
            }
            // check surface pressure
            if (tephi_prof.p0 > -998.) {
              count++;
            }
            this.progress_bar.update_progress_bar(count / nb);
            console.log(data);
          }).catch((error) => {
            tephi_prof.tephi_var[i].diag = null;
            console.error('Error:', error);
          });
        ind++;
      }
    }
    Promise.all(fetchs)
      .then((data) => {
        var OK = 1;
        for (let i = 0; i < tephi_prof.tephi_var.length; i++) {
          for (let j = 0; j < tephi_prof.tephi_var[i].levels.length; j++) {
            if (tephi_prof.tephi_var[i].data[j] < -998.) {
              OK = 0;
            }
          }
        }
        if (OK == 0) {
          this.id_message.innerHTML = "Probl&egrave;me avec le t&eacute;l&eacute;chargement de certaines donn&eacute;es"
          this.progress_bar.reset_progress_bar(0.);
          return
        }
        this.progress_bar.update_progress_bar(1.);
        this.progress_bar.reset_progress_bar(0.);
        this.request_completed = 1;
        this.compute_td(tephi_prof);
        this.plot_tephi(tephi_prof);
        this.tephi_control.id_message.innerHTML = nb.toString() + " couches t&eacute;l&eacute;charg&eacute;es avec succ&egrave;s"
        //console.log(tephi_prof);
        //this.id_message.innerHTML = "Donn&eacute;es charg&eacute;es : model "+this.id_model.value+", date d'origie "+this.dateo_stmp+", point de grille ("+ this.grid_point_coor+")"
      }).catch((error) => {
        this.tephi_control.id_message.innerHTML = "Requ&ecirc;te termin&eacute;e avec erreurs :-("
        console.error('Error:', error);
      });
  }

  compute_td(tephi_prof) {
    for (let i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_Td].data.length; i++) {
      var found = false;
      var pres = tephi_prof.tephi_var[tephi_prof.ind_Td].levels[i];
      for (let j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++) {
        if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] == pres) {
          found = true;
          tephi_prof.tephi_var[tephi_prof.ind_Td].data[i] =
            tephi_prof.tephi_var[tephi_prof.ind_T].data[j] -
            tephi_prof.tephi_var[tephi_prof.ind_Td].data[i]
        }
      }
      if (!found) {
        alert("Tous les niveaux de Td doivent être inclus dans ceux de la tempérture");
        return;
      }
    }
    tephi_prof.tephi_var[tephi_prof.ind_Td].diag =
      tephi_prof.tephi_var[tephi_prof.ind_T].diag -
      tephi_prof.tephi_var[tephi_prof.ind_Td].diag
  }

  plot_tephi(tephi_prof) {
    mytephi.clear_profile();
    if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
      mytephi.plot_profile_wms(tephi_prof.p0,
        tephi_prof.tephi_var[tephi_prof.ind_T].diag,
        tephi_prof.tephi_var[tephi_prof.ind_T].data,
        tephi_prof.tephi_var[tephi_prof.ind_T].levels,'température','red')
    }
    if (tephi_prof.tephi_var[tephi_prof.ind_Td].present) {
      mytephi.plot_profile_wms(tephi_prof.p0,
        tephi_prof.tephi_var[tephi_prof.ind_Td].diag,
        tephi_prof.tephi_var[tephi_prof.ind_Td].data,
        tephi_prof.tephi_var[tephi_prof.ind_Td].levels,'point de rosée','blue')
    }
    if (tephi_prof.tephi_var[tephi_prof.ind_UU].present) {
      // Find maximum index i of tt points over tephi wind data
      // to plot wind profile to the right of it.
      var found = false;
      var count = 0;
      if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
        for (var i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_UU].data.length; i++) {
          for (var j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++) {
            if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] ==
              tephi_prof.tephi_var[tephi_prof.ind_UU].levels[i]) {
              found = true;
              ij = mytephi.temp_pres_to_i_j(tephi_prof.tephi_var[tephi_prof.ind_T].data[j],
                tephi_prof.tephi_var[tephi_prof.ind_T].levels[j])
              break;
            }
          }
          if (found) {
            if (count == 0) {
              var i_max = ij[0];
              var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
              var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
            } else {
              if (ij[0] > i_max) {
                var i_max = ij[0];
                var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
              }
            }
            count++;
          }
        }
        if (!found) {
          var T_imax = 0;
          var p_imax = 1000.;
          var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
          i_max = ij[0];
        }
      } else {
        var T_imax = 0;
        var p_imax = 1000.;
        var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
        i_max = ij[0];
      }
      mytephi.plot_winds_wms(tephi_prof.p0,
        tephi_prof.tephi_var[tephi_prof.ind_UU].diag,
        tephi_prof.tephi_var[tephi_prof.ind_UU].data,
        tephi_prof.tephi_var[tephi_prof.ind_WD].diag,
        tephi_prof.tephi_var[tephi_prof.ind_WD].data,
        tephi_prof.tephi_var[tephi_prof.ind_UU].levels, i_max, T_imax, p_imax);
    }
    if (tephi_prof.tephi_var[tephi_prof.ind_GZ].present) {
      // Find maximum index i of tt points over tephi wind data
      // to plot GZ profile to the right of it, add space if wind is present
      var found = false;
      var count = 0;
      if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
        for (var i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_GZ].data.length; i++) {
          for (var j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++) {
            if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] ==
              tephi_prof.tephi_var[tephi_prof.ind_GZ].levels[i]) {
              found = true;
              ij = mytephi.temp_pres_to_i_j(tephi_prof.tephi_var[tephi_prof.ind_T].data[j],
                tephi_prof.tephi_var[tephi_prof.ind_T].levels[j])
              break;
            }
          }
          if (found) {
            if (count == 0) {
              var i_max = ij[0];
              var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
              var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
            } else {
              if (ij[0] > i_max) {
                var i_max = ij[0];
                var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
              }
            }
            count++;
          }
        }
        if (!found) {
          var T_imax = 0;
          var p_imax = 1000.;
          var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
          i_max = ij[0];
        }
      } else {
        var T_imax = 0;
        var p_imax = 1000.;
        var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
        i_max = ij[0];
      }
      if (document.getElementById('id_height_no').checked == false){
        mytephi.plot_GZ_profile_wms(tephi_prof.p0,
          tephi_prof.tephi_var[tephi_prof.ind_GZ].diag,
          tephi_prof.tephi_var[tephi_prof.ind_GZ].data,
          tephi_prof.tephi_var[tephi_prof.ind_GZ].levels, T_imax, p_imax);
        }
    }
    this.tephi_control.id_product_displayed.innerHTML = "Affich&eacute; : mod&egrave;le " + this.model + ",\n valide : " + tephi_prof.datev;
  }

  set_url(tephi_prof, mod_lay) {
    return 'https://geo.weather.gc.ca/geomet?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&INFO_FORMAT=application/json&WIDTH=10&HEIGHT=10&I=5&J=5' + '&LAYERS=' + mod_lay + '&QUERY_LAYERS=' + mod_lay + '&CRS=EPSG:4326&BBOX=' + this.bbox + '&TIME=' + tephi_prof.datev_wms_format + '&DIM_REFERENCE_TIME=' + tephi_prof.dateo_wms_format;
  }

  clear_datev_menu() {
    const menu = this.tephi_control.id_datev_menu;
    var ni = menu.options.length - 1;
    for (let i = ni; i >= 0; i--) {
      menu.remove(i);
    }
  }

  set_datev_menu() {
    const menu = this.tephi_control.id_datev_menu;
    let i = 0;
    let ind = 0;
    var datev = new Date(this.dateo.getTime());
    const options = { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', timeZoneName: 'short' };
    while (i <= this.hhh_end) {
      if (i == 1000) {
        console.log("Internale error, runaway loop in set_datev_menu")
        return
      }
      if (datev <= this.now) { ind = i }
      let option = document.createElement("option");
      option.setAttribute('value', Get_Wms_date_format(datev));

      option.appendChild(document.createTextNode('t+' + String(i) + "h : " + datev.toLocaleDateString('fr-fr', options)));
      menu.appendChild(option);
      i = i + this.hh_min_delta_fcst;
      datev.setHours(datev.getHours() + this.hh_min_delta_fcst);
    }
    this.progress_bar.reset_progress_bar(0.);
    menu.selectedIndex = ind;
    this.tephi_control.id_message.innerHTML = "Choisir les variables (cliquer sur le hamburger) et une date de validit&eacute;, et cliquer le point d&eacute;sir&eacute; sur la carte";
  }

  set_pressure_info(tephi_prof) {
    var fetch_data_L = false;
    var p_min = 2000;
    var p_max = -1.;
    if (this.tephi_control.id_temp.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_T].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_T].p_max = this.get_levels(this.tephi_control.id_T_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_T].p_min = this.get_levels(this.tephi_control.id_T_min_level);
      [p_min, p_max] = this.get_pmin_pmax(tephi_prof.tephi_var[tephi_prof.ind_T], p_min, p_max);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_T])
      //alert(tephi_prof.tephi_var[tephi_prof.ind_T].levels)
    }
    if (this.tephi_control.id_td.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_Td].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_Td].p_max = this.get_levels(this.tephi_control.id_Td_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_Td].p_min = this.get_levels(this.tephi_control.id_Td_min_level);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_Td]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_Td].levels)
    }
    if (this.tephi_control.id_wind.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_UU].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_UU].p_max = this.get_levels(this.tephi_control.id_V_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_UU].p_min = this.get_levels(this.tephi_control.id_V_min_level);
      [p_min, p_max] = this.get_pmin_pmax(tephi_prof.tephi_var[tephi_prof.ind_UU], p_min, p_max);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_UU]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_UU].levels)
      tephi_prof.tephi_var[tephi_prof.ind_WD].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_WD].p_max = this.get_levels(this.tephi_control.id_V_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_WD].p_min = this.get_levels(this.tephi_control.id_V_min_level);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_WD]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_WD].levels)
    }
    if (this.tephi_control.id_height_agl.checked || this.tephi_control.id_height_asl.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_GZ].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_GZ].p_max = p_max;
      tephi_prof.tephi_var[tephi_prof.ind_GZ].p_min = p_min;
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_GZ]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_GZ].levels);
    }
    return fetch_data_L;

  }

  get_pmin_pmax(tephi_var, pmin, pmax) {
    if (tephi_var.p_min == "Surface") {
      pmin = 2000;
    } else {
      if (parseInt(tephi_var.p_min) < pmin) {
        pmin = parseInt(tephi_var.p_min);
      }
    }
    if (tephi_var.p_max == "Surface") {
      pmax = 2000;
    } else {
      if (parseInt(tephi_var.p_max) > pmax) {
        pmax = parseInt(tephi_var.p_max);
      };
    }
    return [pmin, pmax];
  }
  get_pressure_list(tephi_var) {
    var list = [];
    if (tephi_var.p_max == "Surface") {
      var p_max_i = 2000;
    } else {
      var p_max_i = parseInt(tephi_var.p_max);
    }
    if (tephi_var.p_min == "Surface") {
      list.push(this.levels.length - 1);
      tephi_var.level = [...list];
      return;
    }
    var p_min_i = parseInt(tephi_var.p_min);
    for (let i = 0; i < this.levels.length; i++) {
      if (this.levels[i] >= p_min_i && this.levels[i] <= p_max_i) {
        list.push(this.levels[i]);
      }
    }
    tephi_var.levels = [...list];
    for (let i = 0; i < tephi_var.levels.length; i++) {
      tephi_var.data.push(-999);
    }
    tephi_var.diag = -999;
  }

  get_levels(id_menu) {
    return id_menu.options[id_menu.selectedIndex].value;
  }

  circle(point, color = 'red') {
    var style = new Style({
      stroke: new Stroke({
        color: color,
        width: 5
      }),
    });
    var featureCircle = new Feature({
      geometry: new Circle(fromLonLat(point), 4000)
    });
    featureCircle.setStyle(style);
    var sourceCircle = new sourceVector({
      projection: 'EPSG:4326',
      features: [featureCircle]
    });
    var vectorCircle = new layerVector({
      source: sourceCircle
    });
    this.map.addLayer(vectorCircle);
    return sourceCircle;
  }

  set_url_date(mod_lay, date_stmp) {
    return 'https://geo.weather.gc.ca/geomet?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&INFO_FORMAT=application/json&WIDTH=10&HEIGHT=10&I=5&J=5' + '&LAYERS=' + mod_lay + '&QUERY_LAYERS=' + mod_lay + '&CRS=EPSG:4326&BBOX=' + this.bbox + '&TIME=' + date_stmp + '&DIM_REFERENCE_TIME=' + this.dateo_stmp;
  }

  find_saved_profile(tephi_prof) {
    var found = null;
    for (var i = 0; i < this.tephi_prof_list.length; i++) {
      found = tephi_prof.is_a_sub_profile(this.tephi_prof_list[i]);
      if (found) {
        return this.tephi_prof_list[i];
      }
    }
  }
}

function Get_First_Date(date) {
  var res = new Date();
  res.setFullYear(date.getFullYear());
  res.setDate(date.getDate());
  res.setHours(date.getHours());
  res.setMinutes(0);
  res.setSeconds(0);
  res.setMilliseconds(0);
  return res;
}
function Get_Wms_date_format(date, hour_only = false) {
  var yyyy = String(date.getUTCFullYear())
  var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
  var dd = String(date.getUTCDate()).padStart(2, '0');
  var hh = String(date.getUTCHours()).padStart(2, '0');
  if (hour_only) {
    return hh;
  } else {
    return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':00:00Z';
  }
}

function Get_graph_date_format(date) {
  var yyyy = String(date.getFullYear())
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var dd = String(date.getDate()).padStart(2, '0');
  var hh = String(date.getHours()).padStart(2, '0');
  return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':00:00';
}

class Progress_bar {

  constructor(canvas) {
    this.canvas = canvas;
  }

  update_progress_bar(percent) {
    var ctx = this.canvas.getContext("2d");
    if (percent < .0001) {
      ctx.fillStyle = "#FFF";
    } else {
      ctx.fillStyle = "#BBB";
    }
    ctx.fillRect(0, .4 * this.canvas.height, this.canvas.width, .2 * this.canvas.height);
    //console.log('Bar width:' +percent*this.canvas.width);
    ctx.fillStyle = "#F00";
    ctx.fillRect(0, .4 * this.canvas.height, percent * this.canvas.width, .2 * this.canvas.height);
  }

  reset_progress_bar() {
    this.update_progress_bar(0);
    this.precent = 0.
  }

}



export { WMS_request }
